import { render } from "./WorkoutList.vue?vue&type=template&id=16dcb4b7"
import script from "./WorkoutList.vue?vue&type=script&lang=js"
export * from "./WorkoutList.vue?vue&type=script&lang=js"

import "./WorkoutList.vue?vue&type=style&index=0&id=16dcb4b7&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__